import React from "react";
import {exactMoneyLabel} from "./helpers.mjs";

export function AgentPrice({ job, agent, label: prefix }) {
  const cost = job.agentCosts?.[agent];
  if (!cost) return <small className="triproutes-agent-price">Цена не записана</small>;
  if (cost.attemptCount === 0 && cost.coverage === "none") return <small className="triproutes-agent-price">Нет вызовов</small>;
  const amount = Number(cost.providerCost);
  const label = cost.providerCost == null ? "Не рассчитано" : amount > 0 && amount < 0.0000005 ? `< 0,000001 ${cost.currency || ""}` : `${amount.toLocaleString("ru-RU", { minimumFractionDigits: 4, maximumFractionDigits: 6 })} ${cost.currency === "USD" ? "$" : cost.currency || ""}`;
  const note = cost.coverage !== "complete" ? "Учтено частично; точная сумма части вызовов неизвестна" : "Сохранённые расходы физических вызовов";
  return <small className="triproutes-agent-price" title={`${exactMoneyLabel(cost.providerCost, cost.currency)}. ${note}`}>{prefix&&`${prefix}: `}{cost.providerCost != null && cost.coverage !== "complete" ? "≥ " : ""}{label}</small>;
}
